import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";

export function useUserProfilePictureQuery(userId: string) {
    return useQuery({
        queryKey: ["profile", "picture", userId],
        staleTime: Infinity,
        queryFn: async () => {
            const imgData = await apiClient.getProfilePicture({
                params: {
                    userId: userId,
                },
            });
            if (imgData.status !== 200) {
                return null;
            }
            return imgData.body;
        },
    });
}
